import { configureStore } from "@reduxjs/toolkit";
import { formdataSlice } from "./slices/applicationFormSlice";
import { applicationsSlice } from "./slices/applicationsSlice";
import { customerSlice } from "./slices/customerSlice";
import { userSlice } from "./slices/userSlice";
import { organisationSlice } from "./slices/organisationSlice";

const store = configureStore({
  reducer: {
    userDetails: formdataSlice.reducer,
    applications: applicationsSlice.reducer,
    user: userSlice.reducer,
    customer: customerSlice.reducer,
    organisation: organisationSlice.reducer,
  },
});
export default store;
